// Date.js
import React from "react";
import "./Date.css";

const Date = () => {
  const eventsData = [
    { date: "2024-04-16", event: "Event A" },
    { date: "2024-04-17", event: "Event B" },
    { date: "2024-04-18", event: "Event C" },
  ];

  return (
    <section className="important-dates" aria-labelledby="dates-heading">
      <header className="dates-header">
        <h5 id="dates-heading" className="section-subheading">
          IMPORTANT DATES
        </h5>
      </header>

      <div className="date-container">
        {eventsData.map(({ date, event }) => (
          <article className="date-item" key={date}>
            <time className="date" dateTime={date}>
              {date}
            </time>
            <span className="event">{event}</span>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Date;
